<template>
  <el-cascader :ref="refs" placeholder="请选择题库" :popper-class="refs" @visible-change="visibleChange" @expand-change="visibleChange" :disabled="disabled" :options="datas" collapse-tags :props="props" filterable v-model="ids"
    @change="checkChange" :show-all-levels="showAllLevels" :clearable="clearable">
    <div slot-scope="{data}" class="node-label">
      <!-- <template v-if="type == 'pc'">
        <i class="iconfont icon-book-openshu-fankai" style="font-size: 15px;" v-if="data.type == 1"></i>
        <i class="iconfont icon-wenjianjia" style="font-size: 15px;margin-top: -1px;" v-else></i>
      </template> -->
      {{ data.name }}
    </div>
  </el-cascader>
</template>

<script>
export default {
  props: {
    value: "",
    showAllLevels: {
      type: Boolean,
      default: false,
    },
    config: {
      type: Object,
      default: () => { return {} },
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    defaultDisabled: {
      type: Array,
      default: () => { return [] },
    },
    tenantGroupId: "",
    defaultOne: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "ms",
    },
  },
  data() {
    return {
      datas: [],
      checkedKeys: [],
      ids: "",
      props: {
        checkStrictly: false,
        label: "name",
        value: 'id',
        emitPath: false,
      },
      isFirst: true,
      hasChildren: false,
      tenantGroup: {},
    }
  },
  watch: {
    value: function (newValue) {
      this.ids = newValue;
      if (this.ids && this.isFirst) {
        this.checkChange(this.ids)
        this.isFirst = false;
      }
    },
    defaultDisabled() {
      this.setChildren(this.datas);
    },
    tenantGroupId(val) {
      this.ids = "";
      this.$emit('input', this.ids);
      this.getData();
    },
  },
  created() {
    this.props = Object.assign(this.props, this.config);
    this.refs = "paper_group_" + new Date().getTime();
    if (localStorage.getItem("tenantGroup_" + this.$root.tenantInfo.code)) {
      this.tenantGroup = JSON.parse(localStorage.getItem("tenantGroup_" + this.$root.tenantInfo.code));
    }
  },
  mounted() {
    this.ids = this.value;
    this.getData();
  },
  methods: {
    getData() {
      let params = {
        parentId: "0",
        tenantCode: this.$root.tenantInfo.code,
        tenantGroupId: this.tenantGroupId || this.tenantGroup.id || "",
      }
      this.loading = true;
      let url = "/api/TestPaper/OneselffTestPaperGroupTree";
      if (this.type == "ms") {
        url = "/api/TestPaper/GetTestPaperGroupTreeByTenantAdmin";
        if (this.$root.tenantInfo.isLeader || this.$root.tenantInfo.code == '1') {
          url = "/api/TestPaper/GetTestPaperGroupTreeByTenantGroup";
        }
      } else if (this.type == "auth") {
        url = "/api/TestPaper/GetTestPaperGroupTreeByTeacher";
      }
      this.https("get", url, params).then(res => {
        this.loading = false;
        if (res.success) {
          this.datas = res.response.children || [];
          this.setChildren(this.datas);
          if (!this.hasChildren && this.props.checkStrictly) {
            this.props.checkStrictly = false;
          }
          if (this.ids && !this.isFirst) {
            this.checkChange(this.ids)
            this.isFirst = true;
          }
        }
      }).catch(() => {
        this.loading = false;
      })
    },
    setChildren(arr) {
      arr.map(item => {
        if (this.defaultOne && !this.ids) {
          this.ids = item.id;
          this.$emit('input', this.ids);
          this.$emit('change', item);
        }
        if (this.defaultDisabled.indexOf(item.id) >= 0) {
          item.disabled = true;
        } else {
          item.disabled = false;
        }
        if (item.children && item.children.length > 0) {
          this.setChildren(item.children);
          this.hasChildren = true;
        }
      })
    },
    checkChange(val) {
      if (this.props.multiple) {
        this.$emit('input', val);
      } else {
        this.$emit('input', Array.isArray(val) ? val[0] : val);
      }
      setTimeout(() => {
        let checkedNodes = this.$refs[this.refs].getCheckedNodes();
        let datas = [];
        checkedNodes.map(item => {
          if (item) {
            datas.push(item.data);
          }
        })
        if (this.props.multiple) {
          this.$emit("change", datas);
        } else {
          let node = this.$refs[this.refs].getCheckedNodes()[0];
          if (node) {
            this.$emit('change', node.data);
          }
        }
        this.isFirst = false;
      });
    },
    visibleChange(val) {
      if (this.props.checkStrictly && val) {
        setTimeout(() => {
          var depts = document.getElementsByClassName(this.refs)[0];
          var btns = depts.getElementsByClassName('el-radio__inner');
          for (let i = 0; i < btns.length; i++) {
            btns[i].onclick = () => {
              this.$refs[this.refs]._data.dropDownVisible = false;
            }
          }
        }, 200);
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.node-label {
  position: relative;
  display: inline-flex;
  align-items: center;

  i {
    margin-right: 2px;
    margin-top: 1px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/PaperCascader.vue